export class BOHealthTechnologyFrecuency{
    id:number;
    quantity:number;
    timeUnit:string;
}